'use strict';

import * as Props from '../Props';

const angular = require('angular');

const CheckboxProperties = {
    Basic: {
        'ControlType': 'Checkbox',
        'Label': {
            name: 'label',
            selectedValue: 'Checkbox',
            type: 'textbox',
            onClickFunction: 'openLanguageDialog',
            addOnButton: 'fa fa-globe'
        },
        'Field Name': Props.getFieldName('Checkbox'),
        'Data Field Name': Props.getDataFieldName('Checkbox'),
        'Display Format' : {
            name: 'display.format',
            type: 'dd',
            options: [
                {
                    value: 'checkbox',
                    key: 'Flat Checkbox Buttons',
                    icon: 'flat-checkbox'
                }, {
                    value: 'fCheckBox',
                    key: 'Futrico Checkbox Buttons',
                    icon:'futrico-checkbox'
                },
                {
                    value: 'buttons',
                    key: 'Buttons Checkbox',
                    icon:'buttons-radios'
                },{
                    value: 'lineCheckbox',
                    key: 'Line Checkbox Buttons',
                    icon: 'line-radio'
                }],
            selectedValue: 'checkbox',
            selectedName: 'Flat Checkbox Buttons',
            selectedIcon:'flat-checkbox',
            onChangeFunction:'setDisplayFormat'
        },
        'Number' : {
            name: 'number.columns',
            selectedValue: 1,
            type: 'number',
            onChangeFunction: 'updateRows',
            min:'1',
            max:'999'
        },
        'Required': {
            name: 'required',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Basic',
            hidden: true
        },
        'FilterValue': {
            isFilterValue: 1,
            hidden: true
        }
    },
    Display: {
        'Read-only': {
            name: 'read.only',
            selectedValue: false,
            type: 'checkbox'
        },
        'Hidden': {
            name: 'hidden',
            selectedValue: false,
            type: 'checkbox'
        },
        'Name': {
            selectedValue: 'Display',
            hidden: true
        }
    },
    Style: angular.copy(Props.labelStyleObject),
    ControlStyle: angular.copy(Props.controlStyleObject),
    Margin: angular.copy(Props.marginObject),
    Advance: {
        'Tabindex': {
            name: 'tabindex',
            selectedValue: '',
            type: 'number'
        },
        'Searchable': angular.copy(Props.Searchable),
        'Reportable': angular.copy(Props.Reportable),
        'customizable-column': angular.copy(Props.Customizable),
        'Name': {
            selectedValue: 'Advanced',
            hidden: true
        }
    },
    Events: {
        Name: angular.copy(Props.elementEventsObject).Name,
        load: angular.copy(Props.elementEventsObject).load,
        change: angular.copy(Props.elementEventsObject).change
    },
    "Data Source": {
        'table': {
            type: 'table',
            headers: ['Label', 'Value', 'Default'],
            list: [
                {
                    id: 1,
                    Label: {
                        name: 'Checkbox 1',
                        type: "text",
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Value: {
                        name: 'checkbox1',
                        type: "text",
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Default: {
                        name: false,
                        type: 'checkbox',
                        inputWidth: ""
                    },
                    selectedValue: {
                        name: false,
                        type: 'checkbox',
                        inputWidth: "",
                        hidden: true
                    },
                    showUpdateOptions: true,
                    relation: {}

                },
                {
                    id: 2,
                    Label: {
                        name: 'Checkbox 2',
                        type: "text",
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Value: {
                        name: 'checkbox2',
                        type: "text",
                        inputWidth: "width:100px;",
                        disable: false,
                    },
                    Default: {
                        name: false,
                        type: 'checkbox',
                        inputWidth: ""
                    },
                    selectedValue: {
                        name: false,
                        type: 'checkbox',
                        inputWidth: "",
                        hidden: true
                    },
                    showUpdateOptions: true,
                    relation: {}
                }
            ],
        },
        'Name': {
            selectedValue: 'datasource',
            hidden: true
        }
    }
};

export default CheckboxProperties;


// WEBPACK FOOTER //
// ./client/app/localStorage/Controls/Checkbox.ts